'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WixRestaurantsAnalyticsDriver = function () {
    function WixRestaurantsAnalyticsDriver(_ref) {
        var nockable = _ref.nockable;

        _classCallCheck(this, WixRestaurantsAnalyticsDriver);

        this._nockable = nockable;
    }

    _createClass(WixRestaurantsAnalyticsDriver, [{
        key: 'start',
        value: function start() {
            return this._nockable.start();
        }
    }, {
        key: 'stop',
        value: function stop() {
            return this._nockable.stop();
        }
    }, {
        key: 'reset',
        value: function reset() {
            return this._nockable.reset();
        }
    }, {
        key: 'restaurantOrderStats',
        value: function restaurantOrderStats(_ref2) {
            var accessToken = _ref2.accessToken,
                restaurantId = _ref2.restaurantId,
                metric = _ref2.metric,
                groupBy = _ref2.groupBy,
                timezone = _ref2.timezone,
                since = _ref2.since,
                until = _ref2.until,
                statuses = _ref2.statuses,
                platforms = _ref2.platforms;

            return this._aRequestFor({
                resource: '/restaurants/' + restaurantId + '/orders/stats',
                query: Object.assign({
                    metric: metric,
                    group_by: groupBy,
                    time_zone: timezone,
                    since: since,
                    until: until
                }, statuses ? { statuses: statuses } : {}, platforms ? { platforms: platforms } : {}),
                accessToken: accessToken
            });
        }
    }, {
        key: 'chainOrderStats',
        value: function chainOrderStats(_ref3) {
            var accessToken = _ref3.accessToken,
                chainId = _ref3.chainId,
                metric = _ref3.metric,
                groupBy = _ref3.groupBy,
                timezone = _ref3.timezone,
                since = _ref3.since,
                until = _ref3.until,
                statuses = _ref3.statuses,
                platforms = _ref3.platforms;

            return this._aRequestFor({
                resource: '/chains/' + chainId + '/orders/stats',
                query: Object.assign({
                    metric: metric,
                    group_by: groupBy,
                    time_zone: timezone,
                    since: since,
                    until: until
                }, statuses ? { statuses: statuses } : {}, platforms ? { platforms: platforms } : {}),
                accessToken: accessToken
            });
        }
    }, {
        key: '_aRequestFor',
        value: function _aRequestFor(_ref4) {
            var _this2 = this;

            var resource = _ref4.resource,
                query = _ref4.query,
                accessToken = _ref4.accessToken;

            var params = { resource: resource, query: query, accessToken: accessToken };

            var _this = {
                delayBy: function delayBy(_ref5) {
                    var ms = _ref5.ms;

                    params.delay = ms;
                    return _this;
                },

                succeedWith: function succeedWith(response) {
                    // response can be an object with {value:...}, or a function
                    params.status = 200;
                    params.response = response;

                    _this2._addRule(params);
                },

                failWith: function failWith(error) {
                    params.status = 400;
                    params.response = error;

                    _this2._addRule(params);
                },

                failWithProtocolError: function failWithProtocolError() {
                    params.status = 200;
                    params.response = '<html></html>';

                    _this2._addRule(params);
                }
            };

            return _this;
        }
    }, {
        key: '_addRule',
        value: function _addRule(_ref6) {
            var resource = _ref6.resource,
                query = _ref6.query,
                accessToken = _ref6.accessToken,
                _ref6$delay = _ref6.delay,
                delay = _ref6$delay === undefined ? 0 : _ref6$delay,
                status = _ref6.status,
                response = _ref6.response;

            this._nockable.nock.get(resource).matchHeader('Authorization', 'Bearer ' + accessToken).query(query).delayConnection(delay).times(-1).reply(status, response);
        }
    }]);

    return WixRestaurantsAnalyticsDriver;
}();

exports.default = WixRestaurantsAnalyticsDriver;


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-restaurants-js-sdk/dist/testkit/WixRestaurantsAnalyticsDriver.js
// module id = 730
// module chunks = 0